import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JsonTransformService } from './service/json-transform.service';
import { RequestService } from './service/backend.service';

@NgModule({
  providers: [JsonTransformService, RequestService],
  exports: [CommonModule, RouterModule],
})
export class CoreModule {}
